"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValueConfigCat = void 0;
const configcat_js_1 = require("configcat-js");
const appConfig_1 = require("../../utils/helpers/config/appConfig");
const envConfig_1 = require("../../utils/helpers/config/envConfig");
const configCatClient = (0, configcat_js_1.getClient)(envConfig_1.envConfig.configCatKey, configcat_js_1.PollingMode.LazyLoad, {
    cacheTimeToLiveSeconds: envConfig_1.envConfig.configCatCacheTTL,
    logger: (0, configcat_js_1.createConsoleLogger)(appConfig_1.appConfig.isDevelopment ? configcat_js_1.LogLevel.Warn : configcat_js_1.LogLevel.Off),
});
function getValueConfigCat(_a) {
    var { key } = _a, params = __rest(_a, ["key"]);
    return __awaiter(this, void 0, void 0, function* () {
        let userObject = undefined;
        if (params.userIdentifier) {
            userObject = new configcat_js_1.User(params.userIdentifier);
        }
        return configCatClient.getValueAsync(key, params.default, userObject);
    });
}
exports.getValueConfigCat = getValueConfigCat;
